<template>
  <div style="color:white;flex:1;padding:5px" class="lg">
    <!-- <div v-if="user != null"> -->
    <div>
      <b-button class="ml-1" variant="light" @click="$emit('menu-clicked')"><font-awesome-icon :icon="['far', 'bars']"  /></b-button>
      <b-button :disabled="!enableToolbar" class="ml-3" variant="light" @click="$emit('new-clicked')"><font-awesome-icon :icon="['far', 'file-plus']"  /></b-button>
      <b-button :disabled="!enableToolbar" class="ml-3" variant="light" @click="$emit('save-clicked')">SAVE</b-button>
      <b-button :disabled="!enableToolbar" class="ml-3" variant="light" @click="$emit('print-clicked')"><font-awesome-icon :icon="['far', 'print']"  /></b-button>
      <b-button :disabled="!enableToolbar" class="ml-3" variant="light" @click="$emit('delete-clicked')"><font-awesome-icon :icon="['far', 'trash-alt']"  /></b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['enableToolbar'])
  }
}
</script>